module.exports = __webpack_public_path__ + "static/media/sf-bay.b69b1926.svg";